<template>
  <div
    class="fixed-header"
    :class="{
      opacity: opacityClass,
      collapsed: !isExpandSidebar,
      mobile: isMobile,
      contextWrapped: isContextWrapped,
      'apnic-staff': canShowSearchBoxForAPNICStaff
    }"
    :style="{ top: styleTopValue }"
  >
    <div class="container">
      <div class="title">
        <h4 v-if="!isMobile">
          {{ header || 'Header' }}
        </h4>
        <h4 v-else>
          <span class="title-mobile__left">DASH</span>
          <span class="title-mobile__right">{{ header || '' }} </span>
        </h4>
        <div v-if="isMobile" class="sidebar-switch" @click="showSidebar">
          <fa icon="bars"></fa>
        </div>
        <div v-else v-show="canShowContextSelector" class="context-selector">
          <template v-if="canShowSearchBoxForAPNICStaff">
            <div class="search-box">
              <SearchBoxForAPNICStaff
                @onSearch="handleSearch"
              ></SearchBoxForAPNICStaff>
            </div>
          </template>
          <template v-if="isContextSelectorWithPrefix">
            <ContextSelectorWithPrefix></ContextSelectorWithPrefix>
          </template>
          <template v-else>
            <ContextSelector></ContextSelector>
          </template>
        </div>
      </div>
      <div
        v-if="isMobile"
        v-show="canShowContextSelector"
        class="context-selector"
      >
        <template v-if="canShowSearchBoxForAPNICStaff">
          <div class="search-box">
            <SearchBoxForAPNICStaff
              @onSearch="handleSearch"
            ></SearchBoxForAPNICStaff>
          </div>
        </template>
        <template v-if="isContextSelectorWithPrefix">
          <ContextSelectorWithPrefix></ContextSelectorWithPrefix>
        </template>
        <template v-else>
          <ContextSelector></ContextSelector>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { PATH } from '../../constants/common';
import mixin from '../../utils/mixin';
import ContextSelector from '../layout/ContextSelector.vue';
import ContextSelectorWithPrefix from '../layout/ContextSelectorWithPrefix.vue';
import SearchBoxForAPNICStaff from '../ui/SearchBoxForAPNICStaff.vue';

export default {
  mixins: [mixin],
  components: {
    ContextSelector,
    ContextSelectorWithPrefix,
    SearchBoxForAPNICStaff
  },
  props: ['header', 'topOnMobile', 'isAccessibleForAPNICStaff'],
  data() {
    return {
      opacityClass: '',
      isContextSelectorWithPrefix: false,
      canShowContextSelector: false
    };
  },
  computed: {
    styleTopValue() {
      if (!this.isMobile) return '40px';

      return `${this.topOnMobile}px`;
    },
    canShowSearchBoxForAPNICStaff() {
      return this.isAccessibleForAPNICStaff && this.isAPNICStaff;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (['/routing-status', '/alerts-routing-status'].includes(to.path)) {
          this.isContextSelectorWithPrefix = true;
        } else {
          this.isContextSelectorWithPrefix = false;
        }

        if (
          [
            PATH.ROUTING_STATUS,
            PATH.ALERTS_ROUTING_STATUS,
            PATH.SUSPICIOUS_TRAFFIC,
            PATH.ALERTS_SUSPICIOUS_TRAFFIC,
            PATH.REQUEST_INSIGHTS_OF_SUSPICIOUS_TRAFFIC
          ].includes(to.name)
        ) {
          this.canShowContextSelector = true;
        } else {
          this.canShowContextSelector = false;
        }
      }
    }
  },
  created: function() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('dataStore', ['searchMemberAccount']),
    handleScroll() {
      if (window.scrollY > 10) {
        this.opacityClass = 'opacity';
      } else {
        this.opacityClass = '';
      }
    },
    showSidebar() {
      this.setIsShowSidebarOnMobile(true);
    },
    handleSearch(val) {
      this.searchMemberAccount(val);
    }
  }
};
</script>

<style lang="scss">
.fixed-header {
  position: fixed;
  top: 40px;
  left: 301px;
  right: 0;
  z-index: 5;

  height: 3.75rem;

  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  color: $text-black;
  transition: all 0.5s;

  &.collapsed {
    left: 65px;
  }

  .container {
    width: 100%;
    height: 3.75rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    .title {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
    }

    h4 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }

    .context-selector {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;

      .search-box {
        margin-right: 1rem;
      }
    }
  }
}

.fixed-header.contextWrapped {
  height: 5.25rem;
}

.mobile.fixed-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 6rem;

  &.apnic-staff {
    height: 8rem;
  }

  .sidebar-switch {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    cursor: pointer;

    svg {
      font-size: 1.2rem;
    }
  }

  .container {
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;

    h4 {
      display: flex;
      align-items: center;

      span {
        margin-right: 0.5rem;
        color: #333333;
        font-size: 1.5rem;
        white-space: nowrap;
      }

      span:nth-child(2) {
        padding-left: 0.5rem;
        border-left: 2px solid $apnic-blue;
        font-size: 1rem;
      }
    }

    .context-selector {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
